<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="section-gap">
        <div class="block">
          <div class="ad-set-module-container">
            <p class="title">广告类型</p>
            <div class="block">
              <el-radio v-model="initialData.advType" :label="0">banner</el-radio>
              <el-radio v-model="initialData.advType" :label="1">弹窗</el-radio>
            </div>
            <p class="title">广告位置</p>
            <div class="block">
                <el-checkbox-group v-model="initialData.showPlace" v-if="initialData.advType == 0">
                  <el-checkbox :label="item.type" v-for="item in initialData.placeTypes" :key="item.type" v-if="item.type != 3">{{item.name}}</el-checkbox>
                </el-checkbox-group>
                <span v-if="initialData.advType == 1" style="font-weight:bold;margin-left:40px;">首页</span>
            </div>
            <p class="title">展示时间段</p>
            <div class="block">
              <el-date-picker
                      v-model="initialData.startTime"
                      type="datetime"
                      placeholder="开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span class="r-top">~</span>
              <el-date-picker
                      v-model="initialData.endTime"
                      type="datetime"
                      placeholder="结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <p class="title">跳转页面</p>
            <div class="block cyzs-w-400">
              <custom-link :link='initialData.link' @update:link="val => { initialData.link = val }"></custom-link>
            </div>
            <p class="title">排序</p>
            <input class="block input width-3" v-model="initialData.sort">
            <p class="title">上传图片</p>
            <div class="block">
              <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
              <span class="upload-img-tips">只能上传 jpg/png 文件，图片尺寸小于1M</span>
              <span v-if="initialData.advType == 1">建议尺寸：540x706</span>
            </div>
            <div class="block">
              <image-component :image="initialData.image" :width="300"></image-component>
            </div>

            <p style="text-align:left;">
              <el-button type="primary" style="margin: 60px 0 40px 0;" @click="saveModuleClick">确定</el-button>
              <el-button type="success" style="margin: 60px 0 40px 0;" @click="backClick">取消</el-button>
            </p>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink'

export default {
  components: { CustomLink },
  data () {
    return {
      // 模块设置
      initialData: {
        link: '',
        image: {
          image: '',
          width: 0,
          height: 0
        },
        startTime: '',
        endTime: '',
        advType: 0,
        sort: 0,
        showPlace: [0],
        placeTypes: []
      },
      advId: 0
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.uploadMainBind()
    })
    if (this.$route.query.advId) {
      this.advId = this.$route.query.advId
    }
    this.getInit()
  },
  methods: {
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: true
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.initialData.image.image = response.data.images.info.path
            this.initialData.image.width = response.data.images.info.width
            this.initialData.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },

    // 保存模块设置
    saveModuleClick () {
      if (this.initialData.advType == 1) {
        this.initialData.showPlace = [3]
      } else if (this.initialData.showPlace.indexOf(3) != -1) {
        let index = this.initialData.showPlace.indexOf(3)
        this.initialData.showPlace.splice(index, 1)
      }

      if (!this.initialData.startTime || !this.initialData.endTime) {
        this.$message('时间不能为空')
      } else if (this.initialData.showPlace.length < 1) {
        this.$message('广告位置至少选择一个')
      } else {
        let params = this.initialData
        params.advId = this.advId
        HttpRequest.post('/admin.php?method=adv.saveMiniAppAdv', params, true).then((response) => {
          if (response.result == 0) {
            this.$message('保存成功')
            setTimeout(() => {
              this.$router.push({
                name: 'miniAppAdv'
              })
            }, 1500)
          } else {
            this.$message(response.msg)
          }
        }, (response) => {

        })
      }
    },
    backClick () {
      this.$router.push({
        name: 'miniAppAdv'
      })
    },
    getInit () {
      HttpRequest.get('/admin.php?method=adv.getMiniAppAdv', {advId: this.advId}, true).then((response) => {
        this.initialData = Object.assign(this.initialData, response.data)
      }, (response) => {

      })
    }
  }
}
</script>
<style lang="less" scoped>
  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .ad-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 300px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
  }
  .white-space {
    white-space: normal;
  }
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
</style>
